import { UserJson } from 'app/types/entities'
import { useUser } from 'app/utils'
import type { TabType } from 'app/components/Tabs'

export type UseTagsManagementReturn = {
  tabs: TabType[]
}

const getWorkspaceTabs = (): TabType[] => [
  { name: `Contacts`, href: `contacts` },
  { name: `Activities`, href: `activities` },
  { name: `Locations`, href: `locations` },
]

const getOrgTabs = (): TabType[] => [
  { name: `Locations`, href: `locations` },
  { name: `Workspaces`, href: `workspaces` },
]

export function useTagsManagement(): UseTagsManagementReturn {
  const user = useUser()
  return {
    tabs: user?.workspaceId ? getWorkspaceTabs() : getOrgTabs(),
  }
}
